var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.imageUrl)?_c(_setup.PictureComp,{attrs:{"imageProfile":"competitor_icon","imageUrl":_setup.getImageUrl(_setup.imageUrl),"alt":_setup.competitionName}}):_c('img',{attrs:{"src":_setup.fallbackSrc,"alt":_setup.competitionName}})
}
var staticRenderFns = []

export { render, staticRenderFns }